import React, { useImperativeHandle } from 'react';
import Clipboard from 'clipboard';
import Styles from './mIndex.module.scss';

export default React.forwardRef(function ClipBoard(_props, ref) {
  const initClipBoard = (text: any) => {
    const clipboard = new Clipboard('#copyClipboard', {
      text() {
        return text;
      },
    });
    document.getElementById('copyClipboard')?.click();
    clipboard.destroy();
  };

  useImperativeHandle(ref, () => ({
    initClipBoard,
  }));

  return (
    <button
      type='button'
      data-clipboard-target='#copyClipboard'
      id='copyClipboard'
      className={Styles.copyClipboard}
    />
  );
});
